/**
 * Copyright (c) 2020
 *
 * @summary calls to dataReport/seoVisibility API
 * @author Julien <julien.donnadieu@yooda.com>
 *
 * Created at     : 2020-11-17 10:21:56
 * Last modified  : 2020-11-17 15:31:17
 */

import axios from '@/api/axios.js'

export default {

    /**
     * @param projectId int
     * @returns Promise
     */
    readAveragePosition (projectId) {
        return axios.get(`/report/data/projects/${projectId}/seo-visibility/average-position`)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readCompareKeywordsPositions (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/seo-visibility/compare-keywords-positions`,filters)
    },

    /**
     * @param projectId int
     * @returns Promise
     */
    readConversion (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/seo-visibility/conversion`,filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readIncomingTraffic (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/seo-visibility/incoming-traffic`,filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readNaturalPositionList (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/seo-visibility/natural-position-list`, filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readPositionRepartition (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/seo-visibility/position-repartition`,filters)
    },

    /**
     * @param projectId int
     * @returns Promise
     */
    readPresenceEvolution (projectId,filters=null) {
        return axios.get(`/report/data/projects/${projectId}/dashboard/seo-visibility/presence-evolution`, filters)
    },

    /**
     * @param projectId int
     * @returns Promise
     */
    readTurnover (projectId,filters=null) {
        return axios.get(`/report/data/projects/${projectId}/seo-visibility/turnover`, filters)
    },

    /**
     * @param projectId int
     * @returns Promise
     */
    readVisibility (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/seo-visibility/visibility`, filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readTopPositionCount (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/seo-visibility/top-position-count`,filters)
    },

    /**
     * @param projectId integer
     * @param keywordId integer
     * @param filters
     * @returns Promise
     */
    readKeywordPositionEvolution (projectId,keywordId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/seo-visibility/keyword-position-evolution/keywords/${keywordId}`, filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readNaturalPositionListSparkline (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/seo-visibility/natural-position-list/sparkline`, filters)
    },
};
